import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Button from 'b2b-ui-components-lib/lib/components/button';
import AddressLocation from '../../../../../../../src/assests/svg/address-location.svg';
import SingleUpgradeCancelModal from 'home/view/manage-feasibility/components/molecules/CancelModal/SingleUpgradeCancel';
import './index.scss';
import { createLeadAsync } from 'home/view/upgrade-order/services';
import { getErrMsg } from 'home/view/upgrade-order/utils';
import { findParamFromUrl, handleError, isAuthForDev, isDevEnv, removeFromSessionStorage, setInSessionStorage } from 'common/utils/app.utils';
import { SESSION_STORAGE } from 'home/view/upgrade-order/constants';
import { JOURNEY_TYPE, LSI_ERRORS, ROUTES, STORAGE_KEY, TYPEOF_ORDER } from 'common/constants/app.constants';
import { MODULE_ID } from 'home/common/constants/constants';

const CircuitDetails = ({ lsiData, fetchLsiDetails, lsiError, isEditing, setLoader, loader, lsiLoading, orderFormState, contactFormState }) => {
  const history = useHistory();

  const [circuitDetails, setCircuitDetails] = useState({
    circuitId: '',
    installationAddress: ''
  });

  const [disabled, setDisabled] = useState({
    proceed: true,
    submit: false
  });

  const [currentLsi, setCurrentLsi] = useState('');
  const [showCanceLeadPopup, setShowCancelLeadPopup] = useState(false);
  const {
    lsiId,
    installationAddress: { line1, city, state, pincode }
  } = lsiData ?? { lsiId: '', installationAddress: { line1, city, state, pincode } };

  const currentInstallationAddress = `${line1 ?? ''}, ${city ?? ''}, ${state ?? ''}: ${pincode ?? ''}`;

  const handleCircuitIdChange = (value) => {
    const circuitId = value?.trim();
    setCurrentLsi(circuitId);
    setCircuitDetails({
      circuitId,
      installationAddress: circuitId === lsiId ? installationAddress : ''
    });

    if (circuitId !== lsiId) {
      setDisabled({
        proceed: false,
        submit: true
      });
    } else if (circuitId === lsiId) {
      setDisabled({
        proceed: true,
        submit: false
      });
    }
  };

  const handleProceedClick = () => {
    fetchLsiDetails(currentLsi);
  };

  const createPnQLead = async () => {
    try {
      setLoader(true);
      const postData = {
        lsi: lsiData?.lsiId,
        partyId: lsiData?.customer?.partyId,
        platform: findParamFromUrl('platform', false) ?? 'AEH',
        source: findParamFromUrl('source', false) ?? 'AEH',
        orderNickName: orderFormState?.orderNickName?.value,
        email: contactFormState?.emailAddress?.value,
        phoneNumber: contactFormState?.phoneNumber?.value,
        customerName: contactFormState?.fullName?.value
      };

      if (orderFormState?.typeOfOrder?.value?.key === TYPEOF_ORDER.SHIFTING) {
        postData['orderType'] = 'CHANGE_ORDER';
        postData['orderSubType'] = TYPEOF_ORDER.SHIFTING;
      }

      const { res, err } = await createLeadAsync(postData);
      const result = await (res && res.data && res.data.result);
      const authorization = await ((res && res.headers && res.headers.Authorization) || (res && res.headers && res.headers.authorization));
      const userType = await ((res && res.headers && res.headers.userType) || (res && res.headers && res.headers.usertype));

      if (err) {
        const errorMsg = getErrMsg(err);
        setLoader(false);
        handleError(err);

        throw new Error(errorMsg);
      }

      if (authorization && userType) {
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN, authorization);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.USER_TYPE, userType);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PARTY_ID, lsiData?.customer?.partyId);
        setInSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.LSI_ID, lsiData?.lsiId);
        setInSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE, JOURNEY_TYPE.SINGLE_UPGRADE_SHIFTING);

        removeFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);

        removeFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.SITE_IN_CHARGE);
        setLoader(false);
      }

      if (result) {
        let redirectUrl = ROUTES.UPGRADE_ORDER + `?partyId=${lsiData?.customer?.partyId}` + `&lsi=${lsiData?.lsiId}` + `&platform=${findParamFromUrl('platform', false) || 'AEH'}`;

        if (isDevEnv() && isAuthForDev()) {
          redirectUrl = redirectUrl + `&isAuth=${findParamFromUrl('isAuth', false)}`;
        }

        history.push(redirectUrl);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (lsiData) {
      const {
        lsiId,
        installationAddress: { line1, city, state, pincode }
      } = lsiData;

      const currentInstallationAddress = `${line1 ?? ''}, ${city ?? ''}, ${state ?? ''}: ${pincode ?? ''}`;

      setCircuitDetails({
        circuitId: lsiId,
        installationAddress: currentInstallationAddress
      });
      setCurrentLsi(lsiId);
      setDisabled({
        proceed: lsiError ? false : true,
        submit: lsiError ? true : false
      });
    } else {
      setDisabled({
        proceed: true,
        submit: true
      });
    }
  }, [lsiData]);

  useEffect(() => {
    if (lsiError) {
      setDisabled({
        proceed: false,
        submit: true
      });
    } else {
      setDisabled({
        proceed: true,
        submit: false
      });
    }
  }, [lsiError]);

  const titleGroup = (
    <div className="head_title">
      <h4>Circuit Details</h4>
      <h5>Please enter the Circuit ID of the site you want to upgrade.</h5>
    </div>
  );
  return (
    <div className="circuit_details_controller">
      {showCanceLeadPopup && <SingleUpgradeCancelModal setshowPopup={setShowCancelLeadPopup} />}
      <Accordion title={titleGroup} isExpanded={true} variant="round">
        <div className="accordion_body">
          <div className="plan_config_details">
            <div className="form_group">
              <Input label="Circuit ID" value={currentLsi} onChange={handleCircuitIdChange} required />
              <Button variant="small_activebtn" displayName="Proceed" disabled={disabled.proceed || isEditing || lsiLoading} onClick={handleProceedClick}>
                {lsiLoading && <span className="loading_icon"></span>}
              </Button>
            </div>
            {lsiError?.length > 0 && <span className="error-message">{lsiError ?? LSI_ERRORS.DEFAULT_MSG}</span>}
            {lsiError?.length === 0 && circuitDetails.installationAddress && (
              <div className="installation_address">
                <div className="address_details">
                  <div className="address_icon">
                    <img src={AddressLocation} alt="Address Icon" />
                  </div>
                  <div className="address_title">
                    <h5>Installation Address</h5>
                    <address>{circuitDetails.installationAddress}</address>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="action_button">
            <Button variant="outlinebtn" displayName="Cancel" onClick={() => setShowCancelLeadPopup(true)}></Button>
            <Button
              displayName="Next"
              disabled={disabled.submit || isEditing || currentLsi === '' || circuitDetails.installationAddress === '' || loader}
              onClick={() => createPnQLead()}
            >
              {loader && <span className="loading_icon"></span>}
            </Button>
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default CircuitDetails;
